import * as z from "zod";

export const deleteSmsTemplate = {
  name: "deleteSmsTemplate" as const,
  input: z.object({ id: z.string() }),
  output: z.boolean(),
};
